import { z } from 'zod'

/**
 * Kept as a raw record (not wrapped in `z.object`) so it can be passed
 * to `createEnv` while still being wrappable with `z.object` in the CI
 * validation test.
 */
export const envSchema = {
  VITE_ENV: z.enum(['dev', 'staging', 'prod', 'beta']),
  VITE_API_URL: z.url(),

  // Auth0
  // Bare hostnames, not URLs — the Auth0 SDK builds the origin itself.
  VITE_AUTH0_DOMAIN: z.string().min(1),
  VITE_AUTH0_CLIENT_ID: z.string().min(1),
  VITE_AUTH0_AUDIENCE: z.url(),
  VITE_AUTH0_ENABLE_PASSWORD_AUTH: z
    .enum(['true', 'false'])
    .transform((v) => v === 'true'),

  // Feature flags
  VITE_FLAGS_PRIMARY_PROVIDER: z.enum(['launchDarkly', 'local']),
  VITE_FLAGS_LAUNCH_DARKLY_CLIENT_SIDE_ID: z.string(),

  // Datadog
  VITE_DATADOG_ENABLED: z
    .enum(['true', 'false'])
    .transform((v) => v === 'true'),
  VITE_DATADOG_APPLICATION_ID: z.string(),
  VITE_DATADOG_CLIENT_TOKEN: z.string(),
  VITE_DATADOG_SERVICE: z.string().min(1),
  VITE_DATADOG_SITE: z.string().min(1),
  VITE_DATADOG_ENV: z.string().min(1),

  // Strapi
  VITE_STRAPI_API_URL: z.url(),
  VITE_STRAPI_API_KEY: z.string().min(1),

  // MeiliSearch
  VITE_MEILI_SEARCH_URL: z.url(),
  VITE_MEILI_SEARCH_API_KEY: z.string().min(1),

  // Event service
  VITE_EVENT_SERVICE_URL: z.url(),
  VITE_EVENT_SERVICE_API_KEY: z.string().min(1),
}
